import { executeRequest, Request } from '@jfs/network'
import { GetMerchantsParser } from '../network/parsers/GetMerchantsParser'
import { getMerchantMidListRequestBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return GetMerchantsParser(respData)
}

const searchMerchantsWithMobile = (tokens: any, mobileNumber: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.searchMerchants,
    method: 'POST',
    config: sitConfig(tokens),
    body: getMerchantMidListRequestBody(mobileNumber ?? ''),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { searchMerchantsWithMobile }
